$('.toggle-title h2').click(function(e){
  e.preventDefault();
  $(this).parents('.single-questions').toggleClass('active');
});
$('.single-tab-item h4').click(function(e){
  e.preventDefault();
  var mytab = $(this).parent().data('item');
  $('.common-tabs').removeClass('active');
  $('.single-tab-item').removeClass('active');
  $(this).parent().addClass('active');
  $('#'+mytab).addClass('active');
});
$('.all-reviews').owlCarousel({
    center:true,
    items:4,
    autoplay:true,
    loop:true,
    nav:true,
    margin:40,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        600:{
            items:2,
            nav:true,
    margin:20
        },
        1000:{
            items:4,
        }
    }
});
$('.all-item').owlCarousel({
  items:3,
  loop:false,
  margin:25,
  responsive:{
      0:{
          items:2
      },
      600:{
          items:3
      },
      1000:{
          items:3
      }
  }
});  
$('.fullp-sliders').owlCarousel({
  items:6,
  loop:true,
  margin:25,
  nav:true,
  dots:false,
  responsive:{
      0:{
          items:2
      },
      600:{
          items:3
      },
      1000:{
          items:6
      }
  }
});  
//Sort random function
  function random(owlSelector){
    owlSelector.children().sort(function(){
        return Math.round(Math.random()) - 0.5;
    }).each(function(){
      $(this).appendTo(owlSelector);
    });
  }
var $owl = $( '.fullp-slider' );
$owl.on('initialize.owl.carousel', function(event){
    var selector = $('.fullp-slider');
    random(selector);
});
$owl.owlCarousel({
  center:true,
  items:6,
  loop:true,
  margin:25,
  nav:false,
  dots:false,
  responsive:{
      0:{
        center:false,
          items:2
      },
      600:{
          items:4
      },
      1000:{
          items:6
      }
  }
});
$(window).on('resize', function(){
  $('.fullp-slider').trigger('refresh.owl.carousel');
  $('.all-item').trigger('refresh.owl.carousel');
  $('.all-reviews').trigger('refresh.owl.carousel');
});
class CountUp {
  constructor(triggerEl, counterEl) {
  const counter = document.querySelector(counterEl)
  const trigger = document.querySelector(triggerEl)
  let num = 0
  const decimals = counter.dataset.decimals

  const countUp = () => {
    if (num < counter.dataset.stop)
      
      // Do we want decimals?
      if (decimals) {
        num += 0.01
        counter.textContent = new Intl.NumberFormat('en-GB', { 
          minimumFractionDigits: 2,
          maximumFractionDigits: 2 
}).format(num)
   }
    else {
      // No decimals
      num++
      counter.textContent = num
    }
  }
  
  const observer = new IntersectionObserver((el) => {
    if (el[0].isIntersecting) {
      const interval = setInterval(() => {
        (num < counter.dataset.stop) ? countUp() : clearInterval(interval)
      }, counter.dataset.speed)
    }
  }, { threshold: [0] })

  observer.observe(trigger)
  }
}

// Initialize any number of counters:
new CountUp('#start1', '#counter1');
new CountUp('#start1', '#counter2');
new CountUp('#start1', '#counter3');
new CountUp('#start1', '#counter4');
new CountUp('#start1', '#counter5');